import script from "./Col3Layout.vue?vue&type=script&setup=true&lang=ts"
export * from "./Col3Layout.vue?vue&type=script&setup=true&lang=ts"

import "./Col3Layout.vue?vue&type=style&index=0&id=ec8d4f96&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec8d4f96"]])

export default __exports__